jQuery($ => {
	function resetState(button) {
		$(button).prop('disabled', false).find(':not(.success):not(.error)').removeClass('d-none').siblings().addClass('d-none');
	}

	function showSuccess(button) {
		$(button).prop('disabled', true).find('.success').removeClass('d-none').siblings().addClass('d-none');
		setTimeout(() => {
			resetState(button);
		}, 2000);
	}

	function showError(button) {
		$(button).prop('disabled', true).find('.error').removeClass('d-none').siblings().addClass('d-none');
		setTimeout(() => {
			resetState(button);
		}, 2000);
	}

	function fallbackCopyTextToClipboard(text) {
		const textArea = document.createElement("textarea");
		textArea.value = text;

		// Avoid scrolling to bottom
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			document.execCommand('copy');
			return true;
		} catch (err) {
			return false;
		} finally {
			document.body.removeChild(textArea);
		}
	}

	function copyTextToClipboard(text) {
		if (!navigator.clipboard) {
			if (fallbackCopyTextToClipboard(text)) {
				return Promise.resolve();
			} else {
				return Promise.reject();
			}
		}
		return navigator.clipboard.writeText(text);
	}

	$('.share-copy-link').click(function (e) {
		e.preventDefault();
		copyTextToClipboard(window.location.href).then(() => {
			showSuccess(this);
		}).catch(() => {
			showError(this);
		});
	});
});
